import React from "react";
//import { Container, Row, Button, Col, Spinner } from "react-bootstrap";
import "../Skeleton.css"; // Import the CSS file for styling

const Skeleton = () => {
  return (
    <div className='skeleton-container'>
      <div className='skeleton-avatar'></div>
      <div className='skeleton-text'></div>
    </div>
  );
};

export default Skeleton;
